module.exports = __webpack_public_path__ + "static/media/envelope-square.7271c7be.svg";